<style>
@import '../../assets/css/tool.css';
</style>

<template>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t($route.name)">
                    <b-button variant="primary" class="mb-3 float-right" @click="getAddWallet()" v-if="permissionList.includes(permission.add)"><font-awesome-icon icon="plus"/> {{$t('setting_wallet.table_add')}}</b-button>
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">
                            <b-button variant="info" size="lg" @click="getEditWallet()" v-if="permissionList.includes(permission.edit)">{{$t('setting_wallet.table_edit')}}</b-button>
                            <b-button variant="danger" size="lg" class="ml-1" @click="deleteWallet()" v-if="permissionList.includes(permission.delete)">{{$t('setting_wallet.table_delete')}}</b-button>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>
                
                <b-modal id="addWallet" :title="$t('setting_wallet.table_add')" @ok="addWallet" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="addWalletForm" @submit.prevent="addWallet">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_wallet.table_code')}}</template>
                            <b-form-input name="code" v-model="ajaxAdd.code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_wallet.table_decimal')}}</template>
                            <b-form-input name="decimal_number" v-model="ajaxAdd.decimal_number"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_wallet.table_sort')}}</template>
                            <b-form-input name="sort" v-model="ajaxAdd.sort"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_wallet.table_remark')}}</template>
                            <b-form-textarea name="remark" v-model="ajaxAdd.remark"></b-form-textarea>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_wallet.table_status')}}</template>
                            <b-form-checkbox name="status" v-model="ajaxAdd.status" size="lg" value="1" unchecked-value="0" switch></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_package.table_filter')}}</template>
                            <b-form-checkbox-group name="filter[]">
                                <b-form-checkbox value="transfer-in" class="mt-2">{{$t('admin.table_transfer_in')}}</b-form-checkbox>
                                <b-form-checkbox value="transfer-out" class="mt-2">{{$t('admin.table_transfer_out')}}</b-form-checkbox>
                                <b-form-checkbox value="deposit" class="mt-2">{{$t('admin.table_deposit_coin')}}</b-form-checkbox>
                                <b-form-checkbox value="exchange" class="mt-2">{{$t('admin.table_exchange')}}</b-form-checkbox>
                                <b-form-checkbox value="withdraw" class="mt-2">{{$t('admin.table_withdraw_coin')}}</b-form-checkbox>
                                <b-form-checkbox value="transfer" class="mt-2">{{$t('admin.table_transfer')}}</b-form-checkbox>
                                <b-form-checkbox value="withdraw-record" class="mt-2">{{$t('admin.table_withdraw_coin_record')}}</b-form-checkbox>
                                <b-form-checkbox value="transaction-record" class="mt-2">{{$t('admin.table_transaction_coin_record')}}</b-form-checkbox>
                                <b-form-checkbox value="trust-in" class="mt-2">{{$t('admin.table_trust_in')}}</b-form-checkbox>
                                <b-form-checkbox value="trust-out" class="mt-2">{{$t('admin.table_trust_out')}}</b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="12" >
                            <template slot="label">{{$t('setting_wallet.table_name_title')}}</template>
                            <b-tabs class="center_pane" justified fill>
                                <b-tab v-for="(lang,key) in ajaxAdd.languageList" :key="key" :title="lang.name">
                                    <b-form-group label-cols="12" label-cols-lg="4">
                                        <template slot="label">{{$t('setting_wallet.table_name')}}</template>
                                        <b-form-input :name="'name[' + lang.code + ']'" v-model="ajaxAdd.name[lang.code]"></b-form-input>
                                    </b-form-group>
                                </b-tab>
                            </b-tabs>
                        </b-form-group>
                    </form>
                </b-modal>
                <b-modal id="editWallet" :title="$t('setting_wallet.table_edit')" @ok="editWallet" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="editWalletForm" @submit.prevent="editWallet">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_wallet.table_code')}}</template>
                            <b-form-input name="code" v-model="ajaxEdit.code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_wallet.table_decimal')}}</template>
                            <b-form-input name="decimal_number" v-model="ajaxEdit.decimal_number"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_wallet.table_sort')}}</template>
                            <b-form-input name="sort" v-model="ajaxEdit.sort"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_wallet.table_remark')}}</template>
                            <b-form-textarea name="remark" v-model="ajaxEdit.remark"></b-form-textarea>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_wallet.table_status')}}</template>
                            <b-form-checkbox name="status" v-model="ajaxEdit.status" size="lg" value="1" unchecked-value="0" switch></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_package.table_filter')}}</template>
                            <b-form-checkbox-group name="filter[]" v-model="ajaxEdit.filter">
                                <b-form-checkbox value="transfer-in" class="mt-2">{{$t('admin.table_transfer_in')}}</b-form-checkbox>
                                <b-form-checkbox value="transfer-out" class="mt-2">{{$t('admin.table_transfer_out')}}</b-form-checkbox>
                                <b-form-checkbox value="deposit" class="mt-2">{{$t('admin.table_deposit_coin')}}</b-form-checkbox>
                                <b-form-checkbox value="exchange" class="mt-2">{{$t('admin.table_exchange')}}</b-form-checkbox>
                                <b-form-checkbox value="withdraw" class="mt-2">{{$t('admin.table_withdraw_coin')}}</b-form-checkbox>
                                <b-form-checkbox value="transfer" class="mt-2">{{$t('admin.table_transfer')}}</b-form-checkbox>
                                <b-form-checkbox value="withdraw-record" class="mt-2">{{$t('admin.table_withdraw_coin_record')}}</b-form-checkbox>
                                <b-form-checkbox value="transaction-record" class="mt-2">{{$t('admin.table_transaction_coin_record')}}</b-form-checkbox>
                                <b-form-checkbox value="trust-in" class="mt-2">{{$t('admin.table_trust_in')}}</b-form-checkbox>
                                <b-form-checkbox value="trust-out" class="mt-2">{{$t('admin.table_trust_out')}}</b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="12" >
                            <template slot="label">{{$t('setting_wallet.table_name_title')}}</template>
                            <b-tabs class="center_pane" justified fill>
                                <b-tab v-for="(lang,key) in ajaxEdit.languageList" :key="key" :title="lang.name">
                                    <b-form-group label-cols="12" label-cols-lg="4">
                                        <template slot="label">{{$t('setting_wallet.table_name')}}</template>
                                        <b-form-input :name="'name[' + lang.code + ']'" v-model="ajaxEdit.name[lang.code]"></b-form-input>
                                    </b-form-group>
                                </b-tab>
                            </b-tabs>
                        </b-form-group>
                    </form>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import {languageList,setting_walletAjaxTable,setting_walletAdd,getSetting_WalletEdit,setting_walletEdit,setting_walletDelete} from '@/system/model/tools'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            validate:true,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',id:'',code:'',decimal_number:'',remark:'',sort:'',status:''},
            ajaxAdd:{code:'',decimal_number:'',sort:10,remark:'',status:1,name:{cn:'',en:''},languageList:[]},
            ajaxEdit:{languageList:[]},
            ajaxRow:'',
            csrfName:'',
            csrfValue:'',
            csrfNameKey:'',
            csrfValueKey:'',
            pageLimit:10,
            errors: [],
            permission:{
                add:'6987D3',
                edit:'C3BC36',
                delete:'F07C90'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('setting_wallet.table_id'),
                width: '144'
            },{
                prop: "code",
                label: this.$t('setting_wallet.table_code'),
                width: '279'
            },{
                prop: "decimal_number",
                label: this.$t('setting_wallet.table_decimal'),
                width: '144'
            },{
                prop: "remark",
                label: this.$t('setting_wallet.table_remark'),
                width: '699'
            },{
                prop: "sort",
                label: this.$t('setting_wallet.table_sort'),
                width: '144'
            },{
                prop: "status",
                label: this.$t('setting_wallet.table_status'),
                width: '144'
            }], 
        }
    },methods:{
        initialize(){
            var self = this;
            var result = setting_walletAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.code,this.ajaxSearch.decimal_number,this.ajaxSearch.remark,this.ajaxSearch.sort,this.ajaxSearch.status);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },getAddWallet(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                var result = languageList();
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.ajaxAdd.languageList = value.data;
                        self.$bvModal.show('addWallet')
                    }
                });
            }
        },addWallet(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                this.preloader(true);
                this.errors = [];
                if(!this.ajaxAdd.code){
                    this.validate = false;
                    this.errors.push('setting_wallet.error_code_empty');
                }
                if(!this.ajaxAdd.sort){
                    this.validate = false;
                    this.errors.push('setting_wallet.error_sort_empty');
                }
                if(this.validate){
                    var form = document.getElementById('addWalletForm');
                    var formData = new FormData(form);
                    formData.append(this.csrfNameKey, this.csrfName); 
                    formData.append(this.csrfValueKey, this.csrfValue); 
                    var result = setting_walletAdd(formData);
                    result.then(function(value){
                        self.preloader(false);
                        if(value.valid){
                            self.$swal.fire({
                                type: 'success',
                                text: self.$t(value.returnMsg),
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }else{
                            var text = "";
                            if(Array.isArray(value.returnMsg)){
                                value.returnMsg.forEach(function (value) {
                                    text += self.$t(value)+"<br />";
                                }); 
                            }else{
                                text = self.$t(value.returnMsg);
                            }

                            self.$swal.fire({
                                type: 'error',
                                html: text,
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }
                    });    
                }else{
                    this.validate = true;
                    this.preloader(false);
                    var text = "";
                    this.errors.forEach(function (value) {
                        text += self.$t(value)+"<br />";
                    }); 
                    
                    this.$swal.fire({
                        type: 'error',
                        html: text,
                        onClose: () => {
                            self.initialize();            
                        }
                    });
                }    
            }     
        },getEditWallet(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                var result = getSetting_WalletEdit(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$bvModal.show('editWallet');
                        self.ajaxEdit = value.data;
                        self.ajaxEdit.languageList = value.language;
                    }else{
                        var text = "";
                        this.errors.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                        
                        this.$swal.fire({
                            type: 'error',
                            html: text
                        });
                    }
                })
            }
        },editWallet(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                this.preloader(true);
                this.errors = [];
                if(!this.ajaxEdit.code){
                    this.validate = false;
                    this.errors.push('setting_wallet.error_code_empty');
                }
                if(!this.ajaxEdit.sort){
                    this.validate = false;
                    this.errors.push('setting_wallet.error_sort_empty');
                }
                if(this.validate){
                    var form = document.getElementById('editWalletForm');
                    var formData = new FormData(form);
                    formData.append(this.csrfNameKey, this.csrfName); 
                    formData.append(this.csrfValueKey, this.csrfValue); 
                    formData.append('id', this.ajaxEdit.id); 
                    var result = setting_walletEdit(formData);
                    result.then(function(value){
                        self.preloader(false);
                        if(value.valid){
                            self.$swal.fire({
                                type: 'success',
                                text: self.$t(value.returnMsg),
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }else{
                            var text = "";
                            if(Array.isArray(value.returnMsg)){
                                value.returnMsg.forEach(function (value) {
                                    text += self.$t(value)+"<br />";
                                }); 
                            }else{
                                text = self.$t(value.returnMsg);
                            }

                            self.$swal.fire({
                                type: 'error',
                                html: text,
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }
                    })
                }else{
                    this.validate = true;
                    this.preloader(false);
                    var text = "";
                    this.errors.forEach(function (value) {
                        text += self.$t(value)+"<br />";
                    }); 
                
                    this.$swal.fire({
                        type: 'error',
                        html: text,
                        onClose: () => {
                            self.initialize();            
                        }
                    });
                } 
            }
        },deleteWallet(){
            if(this.permissionList.includes(this.permission.delete)){
                this.$swal.fire({
                text: this.$t('msg.confirm_delete'),
                type: 'info',
                showCancelButton: true,
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('id', this.ajaxRow); 
                        var result = setting_walletDelete(formData);		
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }else{
                                self.preloader(false);
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
